var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalLogoutImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.9464 0H8.57118C4.12962 0 0.517578 3.61204 0.517578 8.0536V24.1608H8.57118V8.0536H64.9464V64.4288H8.57118V48.3216H0.517578V64.4288C0.517578 68.8704 4.12962 72.4824 8.57118 72.4824H64.9464C69.3879 72.4824 73 68.8704 73 64.4288V8.0536C73 3.61204 69.3839 0 64.9464 0Z",
    fill: "#ad728b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7239 52.3482L52.8579 36.241L32.7239 20.1338V32.2182H0.509521V40.2718H32.7239V52.3482Z",
    fill: "#ad728b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalLogoutImg);
export default __webpack_public_path__ + "static/media/modal-logout-img.6d9050dcf49dbe8d0686967b33ca587e.svg";
export { ForwardRef as ReactComponent };